import { vinculaLogic } from '../vincula/vincula.logic';
import { VinculaHostView, VinculaProjectorView, VinculaStudentView } from '../eval-blocks/EvalBlocksViews';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';

export const vinculaPlugin: ActivityPlugin<'vincula'> = {
  ...vinculaLogic,
  displayName: GAME_MODE_CATALOG.vincula.displayName,
  icon: GAME_MODE_CATALOG.vincula.icon,
  HostView: VinculaHostView,
  StudentView: VinculaStudentView,
  ProjectorView: VinculaProjectorView,
};

export { demoVinculaPayload } from '../vincula/vincula.logic';
